import { createModel } from "@rematch/core";
import { BigNumber } from "bignumber.js";
import axios from "axios";
import { RootModel } from ".";

interface GrantState {
  /** 用户拥有nft类型 0:none  1:hero 2:others*/
  nftType?: 0 | 1 | 2;

  /** 用户拥有nft数量 */
  nftNum: number;

  /** 用户夺宝记录数量 */
  records?: any[];

  /** 用户上次夺宝时间 */
  lastClickTime?: number;

  /** 中奖次数 */
  giftTimes: number;

  /** 可以领奖次数 */
  canRewardTimes: number;

  winCoords: { x: number; y: number }[];

  missCoords: { x: number; y: number }[];

  seconds: number;

  isDataInit: boolean;

  rankingRes: any[];
}

const initGrantState: GrantState = {
  nftNum: 0,
  winCoords: [],
  missCoords: [],
  isDataInit: false,
  canRewardTimes: 0,
  seconds: 100,
  giftTimes: 0,
  rankingRes: [],
};

export const game = createModel<RootModel>()({
  state: initGrantState,
  reducers: {
    setFields(state, fields: Partial<GrantState>): GrantState {
      return {
        ...state,
        ...fields,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchGameContractData(_payload: any, state) {
      const { userInfo, KungFuHeroContract } = state.main;
      if (KungFuHeroContract) {
        let canRewardTimes = await KungFuHeroContract.winnerMints(
          userInfo.address
        );
        dispatch.game.setFields({
          canRewardTimes: new BigNumber(canRewardTimes.toString()).toNumber(),
        });
      }
    },
    async fetchGameData(_payload: any, state) {
      const { userInfo } = state.main;
      let res = await axios.get(
        "https://api.kungfuhero.club/api/v2/nft/game/record",
        {
          params: {
            // address: "0xc30559a69c2654cdb7f1e04200037f026d941313",
            // address: "0xf39D50DCE7812E24ac97037858005fa8cBB8F9DE",
            // address: "0xe9c2D3bF3A898F700CADE5f5F4a89A5E5756f4E4",
            address: userInfo.address,
          },
        }
      );
      let { data } = await axios.get(
        "https://api.kungfuhero.club/api/v2/nft/point/ranking"
      );
      console.log(
        "🚀 ~ file: game.ts ~ line 82 ~ fetchGameData ~ rankingRes",
        data
      );
      const { nftNum, nftType, records, lastClickTimestamp, giftNum, seconds } =
        res.data.data;
      let tempWin: any[] = [];
      let tempMiss: any[] = [];
      Array.isArray(records) &&
        records.forEach((record: any) => {
          if (record.isGift === 1) {
            tempWin.push({
              x: record.x,
              y: record.y,
            });
          } else {
            tempMiss.push({
              x: record.x,
              y: record.y,
            });
          }
        });
      dispatch.game.setFields({
        winCoords: tempWin,
        missCoords: tempMiss,
        lastClickTime: Number(lastClickTimestamp) || 0,
        records: records || [],
        isDataInit: true,
        giftTimes: giftNum || 0,
        rankingRes: data.data,
        seconds,
        nftNum,
        nftType,
      });
    },
    async clickMap(
      coords: {
        x: number;
        y: number;
      },
      state
    ) {
      const { userInfo } = state.main;
      dispatch.modal.setFields({
        gameResult: {
          open: true,
          status: 0,
        },
      });
      try {
        let res = await axios.post(
          "https://api.kungfuhero.club/api/v2/nft/game/click",
          {
            // address: "0xc30559a69c2654cdb7f1e04200037f026d941313",
            // address: "0xf39D50DCE7812E24ac97037858005fa8cBB8F9DE", // jason
            // address: "0xe9c2D3bF3A898F700CADE5f5F4a89A5E5756f4E4",
            address: userInfo.address,
            x: coords.x,
            y: coords.y,
          }
        );
        if (res.data.code === 0) {
          dispatch.modal.setFields({
            gameResult: {
              open: true,
              status: 1,
              isGift: Boolean(res.data.data.isGift),
            },
          });
        } else {
          dispatch.modal.setFields({
            gameResult: {
              open: true,
              status: 2,
              errorMsg: res.data.msg || "error",
            },
          });
        }

        dispatch.game.fetchGameData();
      } catch (error) {
        dispatch.modal.setFields({
          gameResult: {
            open: true,
            status: 2,
            errorMsg: "Plase try again.",
          },
        });
      }
    },
    async winnerGetReward(_payload, state) {
      const { KungFuHeroContract } = state.main;
      if (KungFuHeroContract) {
        let mintHash;
        try {
          mintHash = await KungFuHeroContract.winnerGetReward();
          if (mintHash) {
            dispatch.main.setTransactionModal({
              open: true,
              status: 0,
              txHash: mintHash.hash,
            });
          }
          let result = await mintHash.wait();
          if (result.status === 1) {
            dispatch.main.setTransactionModal({
              txHash: mintHash.hash,
              open: true,
              status: 1,
            });
          }
          dispatch.game.fetchGameData();
        } catch (error) {
          if (error?.code === 4001) {
            // 用户取消连接网站
            dispatch.main.openAlert({
              type: "error",
              content: error.message,
            });
          } else {
            dispatch.main.setTransactionModal({
              txHash: mintHash?.hash,
              open: true,
              status: 2,
              errorMsg: error.message,
            });
          }
        }
      }
    },
  }),
});
